// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import "chartkick/highcharts"

Turbo.session.drive = false
Turbo.config.forms.mode = 'optin'
